(() => {
  const initStage = (stage) => {
    if (!stage || stage.dataset.pcsInit === 'true') return;
    stage.dataset.pcsInit = 'true';

    const heading = stage.querySelector('.pcs__heading');
    const logo = stage.querySelector('[data-pcs-logo]');
    const lockup = stage.querySelector('.pcs__lockup');

    const syncLogoWidth = () => {
      if (!logo || !heading) return;
      const width = heading.getBoundingClientRect().width;
      if (width > 0) {
        const value = `${Math.round(width * 100) / 100}px`;
        logo.style.width = value;
        logo.style.minWidth = value;
        lockup?.style.setProperty('--pcs-heading-width', value);
      }
    };

    syncLogoWidth();
    document.fonts?.ready?.then(syncLogoWidth);
    window.addEventListener('resize', syncLogoWidth, { passive: true });
    if (heading && 'ResizeObserver' in window) {
      new ResizeObserver(syncLogoWidth).observe(heading);
    }

    const blobs = [...stage.querySelectorAll('[data-pcs-blob]')].map((el) => ({
      el,
      x: Number(el.getAttribute('data-x')) || 0,
      y: Number(el.getAttribute('data-y')) || 0,
    }));

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canParallax = !reduced && window.matchMedia('(pointer: fine)').matches;

    let targetX = 0.5;
    let targetY = 0.5;
    let currentX = 0.5;
    let currentY = 0.5;
    const smoothing = 0.085;

    const apply = (nx, ny) => {
      blobs.forEach(({ el, x, y }) => {
        el.style.transform = `translate3d(${x * nx}px, ${y * ny}px, 0)`;
      });
    };

    apply(currentX, currentY);

    if (!canParallax) return;

    window.addEventListener(
      'mousemove',
      (event) => {
        const w = window.innerWidth || 1;
        const h = window.innerHeight || 1;
        targetX = event.clientX / w;
        targetY = event.clientY / h;
      },
      { passive: true }
    );

    const tick = () => {
      currentX += (targetX - currentX) * smoothing;
      currentY += (targetY - currentY) * smoothing;
      apply(currentX, currentY);
      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const start = () => {
    document.querySelectorAll('[data-pcs-stage]').forEach(initStage);
  };

  start();
  document.addEventListener('shopify:section:load', start);
})();

class PcsPasswordModal extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    const stage = this.closest('.pcs');
    const input = this.querySelector('input[type="password"]');

    const syncOpen = () => {
      stage?.classList.toggle('is-login-open', this.details.open);
      if (this.details.open) {
        requestAnimationFrame(() => input?.focus());
      }
    };

    if (this.querySelector('input[aria-invalid="true"]')) {
      this.details.open = true;
    }

    syncOpen();
    this.details.addEventListener('toggle', syncOpen);

    this.querySelector('[data-pcs-close]')?.addEventListener('click', () => {
      this.details.open = false;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.details.open) {
        this.details.open = false;
      }
    });
  }
}

if (!customElements.get('pcs-password-modal')) {
  customElements.define('pcs-password-modal', PcsPasswordModal);
}
